import { lazy } from "react";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "./admin/ProtectedRoute";

// Lazy load all page components for code splitting
// This significantly reduces initial bundle size

// Home pages - loaded with slightly higher priority
const UsaHome = lazy(() => import("./pages/UsaHome"));
const Home = lazy(() => import("./pages/Home"));

// AI Services pages
const AiChatBotServices = lazy(() => import("./pages/AiChatBotServices"));
const AIChatBotServicesNewYork = lazy(() => import("./pages/AIChatBotServicesNewYork"));
const AIChatBotServicesCalifornia = lazy(() => import("./pages/AIChatBotServicesCalifornia"));
const AIChatBotServicesTexas = lazy(() => import("./pages/AIChatBotServicesTexas"));
const AIChatBotServicesFlorida = lazy(() => import("./pages/AIChatBotServicesFlorida"));
const AIAgentDevelopment = lazy(() => import("./pages/AIAgentDevelopment"));
const AiMlServices = lazy(() => import("./pages/AiMlServices"));
const AiAutomationAgency = lazy(() => import("./pages/AiAutomationAgency"));
const ComputerVisionDevelopmentServices = lazy(() => import("./pages/ComputerVisionDevelopmentServices"));
const AiAutomationIntigration = lazy(() => import("./pages/AiAutomationIntigration"));
const GenerativeAi = lazy(() => import("./pages/GenerativeAi"));

// Core Services pages
const CustomDevelopment = lazy(() => import("./pages/CustomDevelopment"));
const WebAppServices = lazy(() => import("./pages/WebAppServices"));
const MobileDevelopmentServices = lazy(() => import("./pages/MobileDevelopmentServices"));
const DevOpsServices = lazy(() => import("./pages/DevOpsServices"));
const SoftwareQualityAssurance = lazy(() => import("./pages/SoftwareQualityAssurance"));
const DataAndAnalytics = lazy(() => import("./pages/DataAndAnalytics"));
const BlockChainAnalytics = lazy(() => import("./pages/BlockChainAnalytics"));
const EcommerceServices = lazy(() => import("./pages/EcommerceServices"));

// Hire pages
const HireRubyAndRails = lazy(() => import("./pages/HireRubyAndRails"));
const HireDjango = lazy(() => import("./pages/HireDjango"));
const HirePython = lazy(() => import("./pages/HirePython"));
const HireGoLang = lazy(() => import("./pages/HireGoLang"));
const HireJavaScript = lazy(() => import("./pages/HireJavaScript"));
const HireReact = lazy(() => import("./pages/HireReact"));
const HireAngular = lazy(() => import("./pages/HireAngular"));
const HireFluter = lazy(() => import("./pages/HireFluter"));
const HireAndroid = lazy(() => import("./pages/HireAndroid"));
const HireMernStack = lazy(() => import("./pages/HireMernStack"));
const HireNode = lazy(() => import("./pages/HireNode"));
const HireReactNative = lazy(() => import("./pages/HireReactNative"));
const HireMobileAIMLEngeniers = lazy(() => import("./pages/HireMobileAIMLEngeniers"));
const HireDataScientestPage = lazy(() => import("./pages/HireDataScientestPage"));
const HIreMachineLearning = lazy(() => import("./pages/HIreMachineLearning"));
const HireDevOps = lazy(() => import("./pages/HireDevOps"));
const HireContactPage = lazy(() => import("./pages/HireContactPage"));

// Other pages
const ContactUs = lazy(() => import("./pages/ContactUs"));
const Industry = lazy(() => import("./pages/Industry"));
const LifeAtBitsclan = lazy(() => import("./pages/LifeAtBitsclan"));
const BlogDetails = lazy(() => import("./pages/BlogDetails"));
const Potfoliio = lazy(() => import("./pages/Potfoliio"));
const IndustryDetailNew = lazy(() => import("./pages/IndustryDetailNew"));
const EngagmentModel = lazy(() => import("./pages/EngagmentModel"));
// const Blogs = lazy(() => import("./pages/Blogs"));
const CaseStudies = lazy(() => import("./pages/CaseStudies"));
const NewCaseStudyDetails = lazy(() => import("./pages/NewCaseStudyDetails"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const LeadMaget = lazy(() => import("./pages/LeadMaget"));
const PageNotFound = lazy(() => import("./pages/404page"));
const AuraClinic = lazy(() => import("./pages/AuraClinic"));
const BimiLogo = lazy(() => import("./components/BimiLogo/BimiLogo"));

// Contact component
const Contact = lazy(() => import("./components/contactForm/Contact"));

// Admin panel (isolated under /admin + /login)
const Login = lazy(() => import("./admin/pages/Login"));
const AdminDashboard = lazy(() => import("./admin/pages/AdminDashboard"));
const AdminBlogList = lazy(() => import("./admin/pages/AdminBlogList"));
const AdminBlogAdd = lazy(() => import("./admin/pages/AdminBlogAdd"));
const AdminBlogEdit = lazy(() => import("./admin/pages/AdminBlogEdit"));
const AdminCategoryList = lazy(() => import("./admin/pages/AdminCategoryList"));
const AdminCategoryAdd = lazy(() => import("./admin/pages/AdminCategoryAdd"));
const AdminCategoryEdit = lazy(() => import("./admin/pages/AdminCategoryEdit"));
const AdminAuthorList = lazy(() => import("./admin/pages/AdminAuthorList"));
const AdminAuthorAdd = lazy(() => import("./admin/pages/AdminAuthorAdd"));
const AdminAuthorEdit = lazy(() => import("./admin/pages/AdminAuthorEdit"));

export const routes = [
  { path: "/", element: <UsaHome /> },
  { path: "/about-us", element: <LifeAtBitsclan /> },
  {
    path: "/ai-chatbot-development-services",
    element: <AiChatBotServices />,
  },
  {
    path: "/ai-consultation-services",
    element: <AiAutomationIntigration />,
  },
  {
    path: "/ai-chatbot-development-newyork",
    element: <AIChatBotServicesNewYork />,
  },
  {
    path: "/california-ai-chatbot-development-services",
    element: <AIChatBotServicesCalifornia />,
  },
  {
    path: "/ai-chatbot-development-company-texas",
    element: <AIChatBotServicesTexas />,
  },
  {
    path: "/florida-ai-chatbot-development-agency",
    element: <AIChatBotServicesFlorida />,
  },
  {
    path: "/ai-agent-development-services",
    element: <AIAgentDevelopment />,
  },
  {
    path: "/ai-ml-development-services",
    element: <AiMlServices />,
  },
  {
    path: "/ai-automation-agency",
    element: <AiAutomationAgency />,
  },
  {
    path: "/computer-vision-development-services",
    element: <ComputerVisionDevelopmentServices />,
  },
  {
    path: "/generative-ai-development-services",
    element: <GenerativeAi />,
  },
  {
    path: "/custom-software-development-services",
    element: <CustomDevelopment />,
  },
  { path: "/web-app-development-services", element: <WebAppServices /> },
  {
    path: "/mobile-app-development-services",
    element: <MobileDevelopmentServices />,
  },
  { path: "/dev-ops-services", element: <DevOpsServices /> },
  {
    path: "/quality-assurance-services",
    element: <SoftwareQualityAssurance />,
  },
  { path: "/data-analytics-services", element: <DataAndAnalytics /> },
  {
    path: "/blockchain-development-services",
    element: <BlockChainAnalytics />,
  },
  // Retired page. This handles in-app navigation only — a direct hit or a
  // crawler is 301'd to "/" by the server (see server.js REDIRECTS and the
  // .htaccess rule), which is what passes the old URL's ranking to the home
  // page. `replace` keeps the dead URL out of the browser's back history.
  { path: "/cyber-security-services", element: <Navigate to="/" replace /> },
  { path: "/contact-us", element: <ContactUs /> },
  { path: "/Industries", element: <Industry /> },
  // { path: "/life-at-bitsclan", element: <LifeAtBitsclan /> },
  { path: "/hire-ruby-on-rails-developer", element: <HireRubyAndRails /> },
  { path: "/hire-data-scientists-engineers", element: <HireDataScientestPage /> },
  { path: "/hire-machine-learning-engineers", element: <HIreMachineLearning /> },
  { path: "/hire-devops-engineers", element: <HireDevOps /> },
  { path: "/hire-django-developer", element: <HireDjango /> },
  { path: "/hire-python-developers", element: <HirePython /> },
  { path: "/hire-golang-developer", element: <HireGoLang /> },
  { path: "/hire-javascript-developer", element: <HireJavaScript /> },
  { path: "/hire-react-js-developers", element: <HireReact /> },
  { path: "/hire-angular-developer", element: <HireAngular /> },
  { path: "/hire-flutter-developers", element: <HireFluter /> },
  { path: "/hire-react-native-developers", element: <HireReactNative /> },
  { path: "/hire-mobile-ai-ml-engineers", element: <HireMobileAIMLEngeniers /> },
  { path: "/hire-android-developers", element: <HireAndroid /> },
  { path: "/hire-mern-stack-developer", element: <HireMernStack /> },
  { path: "/hire-node-js-developer", element: <HireNode /> },
  { path: "/contact-us", element: <HireContactPage /> },
  // { path: "/blogs/:id", element: <BlogDetails /> },
  { path: "/case-studies/:slug", element: <NewCaseStudyDetails /> },
  // Closed off — the Potfoliio page component is still in the project, its URL
  // just 301s to home now (see server.js REDIRECTS and the .htaccess rule).
  // Without this entry the path falls through to the "*" route and renders the
  // 404 page instead. To bring the page back, restore the line below.
  // { path: "/portfolio", element: <Potfoliio /> },
  { path: "/portfolio", element: <Navigate to="/" replace /> },
  { path: "/industries/:slug", element: <IndustryDetailNew /> },
  { path: "/newhome", element: <Home /> },
  { path: "/engagment-model", element: <EngagmentModel /> },
  { path: "/test", element: <Contact /> },
  // { path: "/blogs", element: <Blogs /> },
  { path: "/case-studies", element: <CaseStudies /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/terms-and-conditions", element: <TermsAndConditions /> },
  { path: "/ecommerce-services", element: <EcommerceServices /> },
  { path: "/solutions/auraclinic", element: <AuraClinic /> },
  { path: "/bimi/logo", element: <BimiLogo /> },
  {
    path: "/lead-magnet",
    element: <LeadMaget />,
  },

  // ----------------------------- Admin panel -----------------------------
  { path: "/login", element: <Login /> },
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/blogs",
    element: (
      <ProtectedRoute>
        <AdminBlogList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/blogs/add",
    element: (
      <ProtectedRoute>
        <AdminBlogAdd />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/blogs/edit/:id",
    element: (
      <ProtectedRoute>
        <AdminBlogEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/categories",
    element: (
      <ProtectedRoute>
        <AdminCategoryList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/categories/add",
    element: (
      <ProtectedRoute>
        <AdminCategoryAdd />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/categories/edit/:key",
    element: (
      <ProtectedRoute>
        <AdminCategoryEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/authors",
    element: (
      <ProtectedRoute>
        <AdminAuthorList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/authors/add",
    element: (
      <ProtectedRoute>
        <AdminAuthorAdd />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/authors/edit/:id",
    element: (
      <ProtectedRoute>
        <AdminAuthorEdit />
      </ProtectedRoute>
    ),
  },

  {
    path: "*",
    element: <PageNotFound />,
  },
];
